/* eslint-disable prefer-template */
/* eslint-disable func-style */

function padNumber(num, size = 2) {
  let s = String(num);
  while (s.length < size) {
    s = "0" + s;
  }
  return s;
}

let bold = function bold(cell, formatterParams, onRendered) {
  if (cell) {
    let value = cell.getValue();
    return "<b>" + value + "</b>";
  } else {
    return "";
  }
};

let title = function title(cell, formatterParams, onRendered) {
  // plain text value
  //   var value = cell.getValue();
  let row = cell.getRow().getData();
  // console.log(row);
  // cell.getValue();
  // let partNumber = row.getCell('partNumber');
  let value = cell.getValue();
  let formattedCell = value;

  // console.log(partNumber);
  if (row.partNumber) {
    formattedCell = "<b>" + value + " (" + row.partNumber + ")</b>";
  } else {
    formattedCell = "<b>" + value + "</b>";
  }

  if (row.linkDetailpage) {
    const anchor = document.createElement("a");
    anchor.innerHTML = formattedCell;
    // get only Detail JSP (WEB-1414)
    // anchor.href = "details/" + row.linkDetailpage.split("/").pop();
    anchor.href = row.linkDetailpage;

    formattedCell = anchor;
  }
  return formattedCell;
};

let versionNumber = function versionNumber(cell, formatterParams, onRendered) {
  // plain text value
  //   var value = cell.getValue();
  let row = cell.getRow().getData();
  // console.log(row);
  // cell.getValue();
  // let partNumber = row.getCell('partNumber');
  let value = cell.getValue();
  let formattedCell = value;
  let convertedVersion;

  if (value) {
    convertedVersion = padNumber(value, 4);
  }
  // let convertedVersion = value;

  // convertedVersion = convertedVersion.toString().slice(-2) + convertedVersion.toString().slice(0,2);

  // console.log(partNumber);
  if (convertedVersion) {
    formattedCell = convertedVersion;
  } else {
    formattedCell = "<b>" + value + "</b>";
  }

  if (row.linkDetailpage) {
    const anchor = document.createElement("a");
    anchor.innerHTML = formattedCell;
    anchor.className = "tableanchor";
    // get only Detail JSP (WEB-1414)
    // anchor.href = "details/" + row.linkDetailpage.split("/").pop();
    anchor.href = row.linkDetailpage;

    formattedCell = anchor;
  }
  return formattedCell;
};

let lang = function title(cell, formatterParams, onRendered) {
  // plain text value
  //   var value = cell.getValue();
  let row = cell.getRow().getData();
  let value = cell.getValue();
  let formattedCell = value;

  // console.log(partNumber);
  // if (row.languageName) {
  //   formattedCell = row.languageName;
  // }

  if (row.linkDetailpage) {
    const anchor = document.createElement("a");
    anchor.innerHTML = formattedCell;
    // get only Detail JSP (WEB-1414)
    // anchor.href = "details/" + row.linkDetailpage.split("/").pop();
    anchor.href = row.linkDetailpage;

    anchor.className = "tableanchor";

    formattedCell = anchor;
  }
  return formattedCell;
};

let downloadIcon = function downloadIcon(cell, formatterParams, onRendered) {
  if (cell) {
    let link = cell.getValue();
    return (
      "<a href='" +
      link +
      "' target='_blank'><span class='nordicon-download '></span> Download</span></a>"
    );
  } else {
    return "";
  }
};

export { bold, title, versionNumber, lang, downloadIcon };
